import { useNavigate } from 'react-router-dom'
import { useMilemarkerData } from '../hooks/milemarker/useMilemarkerData'
import { ScreenPath } from '../navigation'
import AppShell from '../ui/layout/AppShell'
import MilemarkerTeamList from '../ui/milemarker/MilemarkerTeamList'
import TeamFilterPills from '../ui/milemarker/TeamFilterPills'
import SectionLabel from '../ui/primitives/SectionLabel'
import styles from '../ui/milemarker/MilemarkerScreen.module.css'

export default function LeaderboardScreen() {
  const navigate = useNavigate()
  const { data, isLoading, error } = useMilemarkerData()

  if (isLoading) {
    return (
      <AppShell>
        <h1 className={styles.title}>Milemarker</h1>
        <p className={styles.loading}>Loading…</p>
      </AppShell>
    )
  }

  if (error || !data) {
    return (
      <AppShell>
        <h1 className={styles.title}>Milemarker</h1>
        <p className={styles.empty}>Could not load leaderboard.</p>
      </AppShell>
    )
  }

  return (
    <AppShell>
      <h1 className={styles.title}>Milemarker</h1>
      <SectionLabel>Teams</SectionLabel>
      <div className={styles.filters}>
        <TeamFilterPills
          value={data.memberFilter}
          options={data.memberFilterOptions}
          onChange={data.setMemberFilter}
        />
      </div>
      <MilemarkerTeamList
        teams={data.teams}
        onSelectTeam={
          data.viewerHasTeam ? (teamID) => navigate(`${ScreenPath.team}/${teamID}`) : undefined
        }
      />
    </AppShell>
  )
}
